import React from 'react'
import { Column } from "react-table";
import PaidStatusCell from "../components/PaidStatusCell";
import { PAYMENT } from "./constants";

export default [
    {
        Header: 'Name',
        accessor: row => `${row.first_name} ${row.last_name}`,
        width: "100%"
    },
    {
        Header: 'Email',
        accessor: 'email',
        width: 300
    },
    {
        Header: 'Country',
        accessor: row => row.country.name,
        width: 200
    },
    {
        Header: 'Participations',
        accessor: "participations_count",
        width: 200
    },
    {
        Header: 'Paid',
        id: 'paid',
        accessor: row => row.payments?.length ? (row.payments[0].method !== "manual" ? PAYMENT.manual : PAYMENT.paid) : PAYMENT.notPaid,
        width: 60,
        Cell: PaidStatusCell,
        filter: (rows, id, filterValue) => {
            if (filterValue === undefined)
                return rows
            
            if (filterValue === false)
                return rows.filter(customer => customer.values.paid === PAYMENT.notPaid)
            
            return rows.filter(customer => customer.values.paid !== PAYMENT.notPaid)
        }
    }
] as Column<Interfaces.Customer>[]